// Product data — images from Unsplash (curated sneakers)
export const products = [
  {
    id: "aero-runner-v3",
    name: "Aero Runner V3",
    descriptor: "Featherweight daily trainer",
    price: 165,
    rating: 4.8,
    reviews: 1284,
    badge: "Best Seller",
    category: "running",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=900&q=80",
    altImage: "https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "solstice-low",
    name: "Solstice Low",
    descriptor: "Everyday lifestyle silhouette",
    price: 135,
    rating: 4.7,
    reviews: 946,
    badge: "New",
    category: "lifestyle",
    image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?auto=format&fit=crop&w=900&q=80",
    altImage: "https://images.unsplash.com/photo-1520256862855-398228c41684?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "grid-trainer",
    name: "Grid Trainer 01",
    descriptor: "Multi-directional cross training",
    price: 155,
    rating: 4.6,
    reviews: 512,
    badge: null,
    category: "training",
    image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?auto=format&fit=crop&w=900&q=80",
    altImage: "https://images.unsplash.com/photo-1600269452121-4f2416e55c28?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "meridian-x",
    name: "Meridian X",
    descriptor: "Carbon-plated race day speed",
    price: 245,
    rating: 4.9,
    reviews: 328,
    badge: "Limited",
    category: "running",
    image: "https://images.unsplash.com/photo-1600185365926-3a2ce3cdb9eb?auto=format&fit=crop&w=900&q=80",
    altImage: "https://images.unsplash.com/photo-1584735175315-9d5df23860e6?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "canvas-court",
    name: "Canvas Court",
    descriptor: "Classic court-inspired low top",
    price: 110,
    rating: 4.5,
    reviews: 1802,
    badge: null,
    category: "lifestyle",
    image: "https://images.unsplash.com/photo-1603787081207-362bcef7c144?auto=format&fit=crop&w=900&q=80",
    altImage: "https://images.unsplash.com/photo-1512374382149-233c42b6a83b?auto=format&fit=crop&w=900&q=80",
  },
  {
    id: "forge-hi",
    name: "Forge Hi",
    descriptor: "Heavy-lift stability platform",
    price: 175,
    rating: 4.7,
    reviews: 421,
    badge: "New",
    category: "training",
    image: "https://images.unsplash.com/photo-1491553895911-0055eca6402d?auto=format&fit=crop&w=900&q=80",
    altImage: "https://images.unsplash.com/photo-1552346154-21d32810aba3?auto=format&fit=crop&w=900&q=80",
  },
];
